import {combineReducers} from '@reduxjs/toolkit';

import constructionCosts from 'App/features/map3DEntities/constructionCosts/constructionCostsSlice';
import indicators from 'App/features/map3DEntities/indicators/indicatorsSlice';
import viewModes3D from 'App/features/map3DEntities/viewModes/viewModes3DSlice';
import interiorDesignSlice from 'App/features/project/interiorDesign/interiorDesignSlice';

const map3DEntities = combineReducers({
  indicators,
  viewModes3D,
  interiorDesign: interiorDesignSlice.reducer,
  constructionCosts,
});

export default map3DEntities;
